import axios from 'axios'

interface CreateAxiosClientsForFastpassArgs {
  eCommerce: {
    baseURL: string
  }
  fortune: {
    apiToken: string
    baseURL: string
    accessToken: string | undefined
    fastpassAdminAccessToken: string | undefined
  }
  cosign: {
    baseURL: string
    xPlatformToken: string | undefined
  }
  butler: {
    baseURL: string
    authorization: string
  }
}

export const createAxiosClientsForFastpass = (args: CreateAxiosClientsForFastpassArgs) => {
  const {
    eCommerce,
    fortune,
    cosign,
    butler,
  } = args

  const baseHeader = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'api-token': fortune.apiToken,
    'x-platform-token': cosign.xPlatformToken,
  } as const

  const eCommerceClient = axios.create({
    baseURL: eCommerce.baseURL,
    headers: baseHeader,
  })

  const eCommerceV2Client = axios.create({
    baseURL: `${eCommerce.baseURL}/v2`,
    headers: baseHeader,
  })

  const fortuneClient = axios.create({
    baseURL: fortune.baseURL,
    headers: {
      ...baseHeader,
      'access-token': fortune.accessToken,
    },
  })

  const fortuneGuestClient = axios.create({
    baseURL: `${fortune.baseURL}/g`,
    headers: {
      ...baseHeader,
      'access-token': fortune.accessToken,
    },
  })

  const fortuneMemberClient = axios.create({
    baseURL: `${fortune.baseURL}/m`,
    headers: {
      ...baseHeader,
      'access-token': fortune.accessToken,
    },
  })

  const fastpassAdminClient = axios.create({
    baseURL: fortune.baseURL,
    headers: {
      ...baseHeader,
      'admin-access-token': fortune.fastpassAdminAccessToken,
    },
  })

  const cosignClient = axios.create({
    baseURL: cosign.baseURL,
    headers: baseHeader,
  })

  const butlerClient = axios.create({
    baseURL: butler.baseURL,
    headers: {
      ...baseHeader,
      Authorization: butler.authorization,
    },
  })

  const clients = {
    cosign: [cosignClient],
    eCommerce: [eCommerceClient],
    eCommerceV2: [eCommerceV2Client],
    fortune: [fortuneClient],
    fortuneGuest: [fortuneGuestClient],
    fortuneMember: [fortuneMemberClient],
    fastpassAdmin: [fastpassAdminClient],
    butler: [butlerClient],
  } as const
  const getClient = (client: keyof typeof clients) => clients[client][0]

  return {
    clients,
    getClient,
  }
}
